import React, {useState} from 'react'
import CustomAppBar from '../components/CustomAppBar'
import { Box, Typography, IconButton, Alert } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom';
import PrimaryButton from '../components/PrimaryButton';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { BiSolidCopy } from 'react-icons/bi';
import SendIcon from '@mui/icons-material/Send';
import CopyableTextBox from '../components/CopyableTextBox';
import { useSelector, useDispatch } from 'react-redux';
import { updateTempGroupName, updateTempGroupHearts, updateTempGroupID } from '../redux/groupSlice';
import { PRIMARY_COLOR } from '../colorPalette';
import TextBox from '../components/TextBox';
import { Snackbar } from '@mui/material';
import { PRIMARY_BUTTON_BLUE } from '../colorPalette';
import SectionBanner2 from '../components/SectionBanner2';
import NumbersIcon from '@mui/icons-material/Numbers';

function NewGroupDone() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // get temp group name from store
    const tempGroupName = useSelector((state) => state.group.tempGroupName);
    const tempGroupHearts = useSelector((state) => state.group.tempGroupHearts);
    const tempGroupID = useSelector((state) => state.group.tempGroupID);
    const [alertOpen, setAlertOpen] = useState(false); // alert popup

    const rowContainerStyles = {
        // backgroundColor: 'yellow', 
        display: 'flex', 
        flexDirection: 'row', 
        marginTop: '10px', 
        alignItems: 'center'
    }

    const handleDoneClick = () => {

        // reset temp group name, hearts, and ID in the store
        dispatch(updateTempGroupName(""));
        dispatch(updateTempGroupHearts([]));
        dispatch(updateTempGroupID(""));

        navigate('/home');
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(tempGroupID);
        setAlertOpen(true);
    }

    const handleCloseAlert = () => {
        setAlertOpen(false);
    };

    return (
        <AppContainer>
            {/* Alert popup */}
            <Snackbar
                open={alertOpen}
                autoHideDuration={3000}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
                    Group ID copied to clipboard.
                </Alert>
            </Snackbar>

            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight }}>
                <CustomAppBar />
                {/* Box to fill space, pushing button to bottom of screen */}
                <Box style={{ flex: 1 }}>
                    <TextContainer>
                        <Typography variant='h5' sx={{marginTop: '40px', textAlign: 'center'}}>
                            <>
                                <Box component="span" sx={{ color: PRIMARY_COLOR }}>
                                    {tempGroupName}
                                </Box>{' '}
                                is ready!
                            </> 
                        </Typography>
                        <Typography variant='body2' sx={{marginTop: '15px', fontSize: '12px', textAlign: 'center', fontStyle: 'italic'}}>Click the copy button to copy the Group ID, then send it to the people you want to join your group.</Typography>
                    </TextContainer>
                    <SectionBanner2 text={"Group ID"} IconComponent={NumbersIcon} />
                    <TextContainer>
                        <Box sx={rowContainerStyles}>
                            {/* <CopyableTextBox propText={tempGroupID} customStyles={{marginLeft: '25px', flexGrow: 1}} /> */}
                            <TextBox propText={tempGroupID} customStyles={{marginLeft: '20px', flexGrow: 1}} />
                            <IconButton onClick={handleCopy} sx={{marginLeft: '10px', color: PRIMARY_BUTTON_BLUE}}>
                                <BiSolidCopy />
                            </IconButton>
                        </Box>
                    </TextContainer>
                </Box>
                {/* Button at the bottom of the screen */}
                <TextContainer customStyles={{marginBottom: '40px'}}>
                    {/* Verify that at least 1 heart was selected */}
                    <PrimaryButton text={"Done"} customStyles={{width: '100%'}} onClick={handleDoneClick}/>
                </TextContainer>
            </Box>
        </AppContainer>
    )
}

export default NewGroupDone